import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';

export function AppShell() {
  // OCP-333 — mobile nav drawer state. Navbar's hamburger opens it; the
  // Sidebar renders the drawer + closes it on link-click / backdrop / Esc.
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();

  // Defensive: ensure the drawer never lingers across a route change.
  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-gray-50 dark:bg-gray-950 text-gray-900 dark:text-gray-100">
      <Navbar onMenuClick={() => setMobileNavOpen(true)} />
      <div className="flex flex-1">
        <Sidebar mobileOpen={mobileNavOpen} onMobileClose={() => setMobileNavOpen(false)} />
        <main className="min-w-0 flex-1 px-4 py-6 sm:px-6 sm:py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
